import React, { useState, useEffect, useCallback } from "react";
import DataTable from "../../../components/AdminTable/DataTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";

function Subscription() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [showModal, setShowModal] = useState(false);

  const [columns] = useState([
    {
      header: "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: "Heading",
      accessorKey: "heading",
    },
    {
      header: "Details",
      accessorKey: "details",
    },
    {
      header: "Service/Delivery Charge",
      accessorKey: "delivery_charges",
    },
    {
      header: "Amount",
      accessorKey: "amount",
    },
    {
      header: "Expire Days",
      accessorKey: "expire_days",
    },
    {
      header: "Actions",
      accessorKey: "SN",
      // cell: (row) => <Dropdown />,
      cell: (row) => (
        <Dropdown id={row.row.original.id} options={dropdownOptions} />
      ),
    },
  ]);

  const navigate = useNavigate();

  const dropdownOptions = [
    {
      name: "Edit",
      icon: <FaEdit />,
      func: (id) => {
        // Handle edit action
        navigate(`AddSubForm/${id}`);
      },
    },
    {
      name: "Delete",
      icon: <FaTrash />,
      func: (id) => {
        // Handle delete action
        handleDelete(id);
      },
    },
  ];

  const [data, setData] = useState([]);

  const [serviceCharge, setServiceCharge] = useState("");

  const handleFormSumbit = (e) => {
    e.preventDefault();

    axios
      .put(
        `${apiKey}/api/rms/admin/serviceDeliveryCharge`,
        { serviceCharge },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then((res) => {
        setServiceCharge(
          JSON.parse(res.data.data.value).service_delivery_charges
        );
        setShowModal(false);
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        console.error("Error updating service delivery charge:", err);
        toast.error(err.response?.data.message || "Error Occured", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const handleDelete = (id) => {
    axios
      .delete(`${apiKey}/api/rms/admin/subscription/${id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        fetchData();
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };

  const fetchData = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/subscription`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setData(res.data.data);
      }).catch(err => {
        
      });
  }, [user?.token]);

  useEffect(() => {
    fetchData();

    axios
      .get(`${apiKey}/api/rms/customer/serviceDeliveryCharge`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setServiceCharge(res.data.data.service_delivery_charges);
      })
      .catch((err) => {
        console.error("Error fetching service delivery charge:", err);
      });
  }, [user?.token, fetchData]);

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="md:flex block flex-wrap justify-between">
          <div>
            <h1 className="text-d-bg-text text-2xl">Subscription</h1>
          </div>

          <div className="mb-2 ">
            <Link
              className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              type="button"
              onClick={() => setShowModal(true)}
            >
              Service/Delivery Charges
            </Link>

            <Link
              className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
              to="AddSubForm"
              type="button"
            >
              Add Subscription
            </Link>
          </div>
        </div>

        <DataTable columns={columns} data={data} />
      </div>

      {showModal && (
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
          <div className="relative mx-auto w-1/3">
            {/*content*/}
            <form
              onSubmit={handleFormSumbit}
              className="border-0 rounded-lg shadow-lg relative flex flex-col bg-white outline-none focus:outline-none overflow-y-auto shiftmodel"
            >
              {/*header*/}
              <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">
                <h1 className="text-xl text-d-bg-text">
                  Service/Delivery Charge
                </h1>
                <button
                  className="ml-auto float-right text-2xl"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  <span className="text-d-bg-text"> × </span>
                </button>
              </div>
              <div className="px-4 text-d-bg-text">Delivery Amount *</div>
              <hr className="min-h-0.5 w-auto mx-2" />

              <div className="p-4">
                <input
                  type="text"
                  placeholder="Select Item"
                  className="placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full p-2"
                  required
                  value={serviceCharge}
                  onChange={(e) => setServiceCharge(e.target.value)}
                />
              </div>

              <div className="flex items-center justify-end p-3">
                <button
                  className="text-d-bg-text text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                  type="button"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
                <button
                  className="bg-d-bg text-white text-md px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                  type="submit"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showModal && (
        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
      )}
    </main>
  );
}

export default Subscription;
